<template>
  <fragment>
    <h3
      class="attachment-name"
      :class="[{uploaded: !!file.objectKey},{required: !!file.isRequired}]"
    >
      <v-icon
        v-if="!!file.objectKey"
        color="var(--app-primary-color)"
      >
        mdi-check-circle
      </v-icon>
      <span v-if="!!file.isRequired">
        *
      </span>

      {{ file.categoryName || file.name }}
    </h3>
    <v-row
      class="attachment-item"
      :class="{placeholder: file.isPlaceholder}"
      @click="file.isPlaceholder ? showModal() : $emit('viewAttachment', { file, attachmentKey: file.attachmentKey })"
    >
      <naj-button
        v-if="file.isPlaceholder && !isViewMode"
        class="add-attachment"
        outlined
        @click="showModal()"
      >
        إضافة
      </naj-button>

      <v-col
        v-if="!file.isPlaceholder"
        class="attachment-item-info"
        cols="10"
      >
        <v-icon class="icon">
          {{
            file.fileType == attachmentType.image ? 'mdi-image-outline' : 'mdi-file-pdf-box-outline'
          }}
        </v-icon>

        <h3 class="file-name">
          {{ file.name }}
          <span
            v-if="file.categoryName"
            class="file-type"
          >{{ file.categoryName }}</span>
        </h3>
      </v-col>
      <v-col
        v-if="showDeleteButton && !file.isPlaceholder && !isViewMode"
        cols="2"
        class="actions"
      >
        <button
          v-if="!file.isAttachmentAudited"
          type="button"
          class="action-btn remove-action"
          @click.stop="
            $emit('deleteAttachment', {
              attachmentKey: file.attachmentKey,
              objectKey: file.objectKey,
            })
          "
        >
          {{ local.common.remove }}
        </button>
      </v-col>
    </v-row>
    <v-row class="p-2">
      <naj-input
        v-if="!file.isPlaceholder && isNotCompleted"
        :type-id="formFieldType.checkbox"
        :value.sync="file.isAttachmentAudited"
        :label="`${local.attachments.attachmentsAudited}`"
        class="inline-label primary-label-color input-container"
        :disabled="true"
      ></naj-input>
    </v-row>
  </fragment>
</template>

<script>
import { attachmentType } from '@/helpers/enum';
import { createNamespacedHelpers } from 'vuex';
const { mapGetters } = createNamespacedHelpers('BankruptcyModule');

export default {
  name: 'AttachmentCard',
  props: {
    file: {
      type: Object,
      required: true,
    },
    showDeleteButton: {
      type: Boolean,
      default: true,
    },

  },
  data() {
    return { attachmentType };
  },
  computed: {
    ...mapGetters([
      'isViewMode',
      'isNewMode',
      'isEditMode',
      'isNotCompleted',
    ]),
  },
  methods: {
    showModal() {
      if (!this.isViewMode) {
        this.$emit('show-modal', this.file.id);
      }
    },
  },
};
</script>

<style lang="scss" scoped>
    .attachment-name {
        font-weight: bold;
        font-size: 14px;
        margin-bottom: 10px;
        color: #999;

        &.uploaded {
            color: var(--app-primary-color);
        }

        &.required {
            content: '*';
            color: #ff3547;
            display: inline-block;
            margin-right: 5px;
        }
    }

.attachment-item {
  height: 100%;
  width: 100%;
  border: 1px solid #cecece;
  height: 69px;
  align-items: center;
  align-content: center;
  &:hover {
    border: 1px solid #75d6ce;
  }
  .add-attachment {
    padding: 6px;
    &::v-deep .naj-button {
      border-radius: 100px;
    }
  }
  &.placeholder {
    display: flex;
    align-items: center;
    justify-content: flex-end;
  }
  .attachment-item-info {
    display: flex;
    align-items: center;
  }
  .icon {
    font-size: 60px;
    color: #000;
  }
  .file-name {
    font-size: 14px;
    display: inline-block;
    .file-type {
      display: block;
      color: #9ea1b3;
      font-weight: 400;
    }
  }
  .actions {
    display: flex;
    justify-content: flex-end;
    .action-btn {
      color: #888;
      cursor: pointer;
      position: relative;
      top: -1px;
      line-height: 1;
      padding: 9px 15px;
      border-radius: 100px;
      font-size: 16px;
      border: 1px solid #888;
      &.remove-action {
        border-color: #e14747;
        color: #e14747;
      }
      &:hover {
        &.remove-action {
          background-color: #e14747;
          color: #fff;
        }
      }
    }
  }
}
</style>
